import { BillingPlanTier } from '@core/products-types';

export const isPp24 = (tier: BillingPlanTier) =>
  [BillingPlanTier.Start, BillingPlanTier.Grow, BillingPlanTier.Optimize].includes(tier);
